import React, { useState } from 'react';
import { Modal, Button, Icon } from '@vacasa/react-components-lib';
import { ApiVisibilityConfig, parseVisibilityConfigTags } from './visibility-config.utils';
import './VisibilityConfigSection.scss';

interface VisibilityConfigSectionProps {
    visibilityConfig: ApiVisibilityConfig;
}

export const VisibilityConfigSection: React.FC<VisibilityConfigSectionProps> = ({ visibilityConfig }) => {
    const [showInfoModal, setShowInfoModal] = useState(false);
    const tags = parseVisibilityConfigTags(visibilityConfig);

    if (tags.length === 0) {
        return null;
    }

    return (
        <div className="visibility-config-section">
            <div className="visibility-config-section__row">
                <div className="visibility-config-section__title-group">
                    <button
                        type="button"
                        className="visibility-config-section__info-btn"
                        onClick={() => setShowInfoModal(true)}
                        aria-label="About channel visibility configuration"
                    >
                        <Icon.PlusCircle className="visibility-config-section__info-icon" width={16} height={16} aria-hidden />
                    </button>
                    <span className="body-small-regular visibility-config-section__title">Channel visibility: </span>
                </div>
                <div className="visibility-config-section__tags" role="list">
                    {tags.map((tag) => (
                        <span
                            key={tag.key}
                            role="listitem"
                            className={`visibility-config-tag ${
                                tag.value ? 'visibility-config-tag--true' : 'visibility-config-tag--false'
                            }`}
                        >
                            {tag.channelLabel}: {tag.value ? 'true' : 'false'}
                        </span>
                    ))}
                </div>
                <br />
            </div>

            <Modal showModal={showInfoModal} setShowModal={() => setShowInfoModal(false)} size="medium">
                <div>
                    <span className="body-small-bold">Channel visibility</span>
                </div>
                <div className="visibility-config-modal-body">
                    <p>
                        For migrated reviews, visibility on Vacasa or Casago depends on the configuration provided by the PM during the
                        migration.
                    </p>
                    <p>
                        Even if Show Rating or Show Public Comment are set to true, the channel where the review is displayed is determined
                        by the PM configuration, which can be defined at the PM level or overridden for specific units.
                    </p>
                    <div className="visibility-config-modal-actions">
                        <Button variant="secondary" customClass="visibility-config-modal-close" onClick={() => setShowInfoModal(false)}>
                            Close
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
